// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"cbf8b2818ad9acaaa157","114":"018baaed003717c9142b","115":"352ed2b6ac4191623fda","162":"3515f753a1b0febd195d"}[chunkId] + ".chunk.js";
};